<template>
  <ul v-if="errors" class="help-block">
    <li v-for="(error, key) in errors" v-bind:key="key">{{ error }}</li>
  </ul>
</template>

<script>

export default {
  name: 'ErrorList',
  props: [
    "errors",
  ],
}
</script>

<style>
</style>
